
        <div
			class="form-group"
			[formGroup]="OBJ_form_group"
			[ngClass]="{'has-error': isInvalid()}">
			<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
            <label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
				<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
				   [tooltip]="tooltipTemplate"
				   placement="top"
				   triggers="click"
				   containerClass="tig-tooltip"
				   delay="50"></i>
                <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
            <div class="col-lg-8">
                <tig-multiselect
					[formControlName]="OBJ_field_config.name"
					[items]="OBJ_field_config.options"
					[settings]="settings"
					(selectedEvent)="selected($event)"
					[disabled]="OBJ_field_config?.readonly"
                ></tig-multiselect>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
                <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
            </div>
        </div>
		<div class="form-group" *ngIf="STR_route_to_self">
			<div class="col-lg-2 control-label"></div>
			<div class="col-lg-8">
				<a href="{{STR_route_to_self}}" target="_blank">{{"oMisc.sEditEntry"|translate}}</a>
			</div>
		</div>
	